module.exports = __webpack_public_path__ + "img/cxzx.b284324b.png";